export function normalizeRoles(
    roles?: string | readonly string[] | null
): string[] {
    if (!roles) {
        return [];
    }

    const values = Array.isArray(roles) ? roles : [roles];

    return values
        .flatMap(role => role.split(','))
        .map(role => role.trim())
        .filter(Boolean);
}
